import { downgradeInjectable, setAngularJSGlobal } from '@angular/upgrade/static';
import * as angular from 'angular';
setAngularJSGlobal(angular);
import { $locationShim } from '@angular/common/upgrade';
import { Store } from '@ngrx/store';
import { AdminCentralSelectors } from '../admin-central/state/admin-central.selectors';
import { AuthenticationActions } from '../auth/state/authentication.actions';
import { AuthenticationSelectors } from '../auth/state/authentication.selectors';
import { ConnectionProfilesSelectors } from '../connection-profile/state/connection-profiles.selectors';
import { EventSharingService } from '../core/event-sharing.service';
import { RouteSelectors } from '../core/state/route/route.selectors';
import { JobService } from '../job/job.service';
import { BlockTimesProximitySelectors } from '../modules/admin/blockTimesAndProximity/state/block-times-proximity.selectors';
import { PreviewEditTemplateSelectors } from '../preview-edit-template/state/preview-edit-template.selectors';
import { ReasonsSettingsSelectors } from '../reasons/state/reasons-settings.selectors';
import { AppointmentListService } from '../reminders/appointment-list/state/appointment-list.service';
import { PatientsActions } from '../reminders/patients/state/patients.actions';
import { PatientsSelectors } from '../reminders/patients/state/patients.selectors';
import { AppointmentResourceSettingsSelectors } from '../resources/state/appointment-resource-settings.selectors';
import { AudioService } from '../services/audio.service';
import { TrackableItemsSelectors } from '../trackable-items/trackable-items.selectors';
import { UserSelectors } from '../user/state/user.selectors';

/**
 * Downgrade Angular service to use in angularJS.
 * - use aliases ending with AService to make it more obvious that it's a downgraded service
 */
angular.module('autoremind')
  .factory('eventSharingService', downgradeInjectable(EventSharingService));

angular.module('autoremind')
    .factory('$location', downgradeInjectable($locationShim));

// Using the `downgradeInjectable` to create the `ngrxStoreService` factory in AngularJS
// https://ngrx.io/guide/store/recipes/downgrade
angular.module('autoremind')
    .factory('authenticationSelectorsDowngraded', downgradeInjectable(AuthenticationSelectors));

angular.module('autoremind')
    .factory('storeDowngraded', downgradeInjectable(Store));

angular.module('autoremind')
    .factory('authenticationActions', downgradeInjectable(AuthenticationActions));

angular.module('autoremind')
    .factory('patientsSelectorsDowngraded', downgradeInjectable(PatientsSelectors));

angular.module('autoremind')
    .factory('patientsAction', downgradeInjectable(PatientsActions));

angular.module('autoremind')
    .factory('previewEditTemplateSelectorsDowngraded', downgradeInjectable(PreviewEditTemplateSelectors));

angular.module('autoremind')
    .factory('blockTimesProximitySelectorsDowngraded', downgradeInjectable(BlockTimesProximitySelectors));

angular.module('autoremind')
    .factory('connectionProfilesSelectorsDowngraded', downgradeInjectable(ConnectionProfilesSelectors));

angular.module('autoremind')
    .factory('audioServiceDowngraded', downgradeInjectable(AudioService));

angular.module('autoremind')
    .factory('jobServiceDowngraded', downgradeInjectable(JobService));

angular.module('autoremind')
    .factory('appointmentServiceDowngraded', downgradeInjectable(AppointmentListService));

angular.module('autoremind')
    .factory('appointmentResourceSettingsSelectorsDowngraded', downgradeInjectable(AppointmentResourceSettingsSelectors));

angular.module('autoremind')
    .factory('reasonsSettingsSelectorsDowngraded', downgradeInjectable(ReasonsSettingsSelectors));

angular.module('autoremind')
    .factory('previewEditSelectorDowngraded', downgradeInjectable(PreviewEditTemplateSelectors));

angular.module('autoremind')
    .factory('adminCentralSelectorDowngraded', downgradeInjectable(AdminCentralSelectors));

angular.module('autoremind')
    .factory('routeSelectorsDowngraded', downgradeInjectable(RouteSelectors));

angular.module('autoremind')
  .factory('userSelectorsDowngraded', downgradeInjectable(UserSelectors));

angular.module('autoremind')
  .factory('trackableItemSelectorDowngraded', downgradeInjectable(TrackableItemsSelectors));
